import React, { useEffect, useState } from 'react';
import { callAPI, remapData } from '../../utils';
import '../../../css/testing.css'
import '../../../css/spinner.css'
import {getConfigTutorData, getConfigStudentData } from "./modals/modalConfigs";

import StaticFieldEditor from './modals/staticFields'
import ErrorList from './modals/errorList';
import ErrorModal from './modals/errorsModal';
import ProgressModal from './modals/progressModal';
import LoadingModal from './modals/loadingModal';

const DataImport = () => {
  const [staticFields, setStaticFields] = useState({});
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const [oldData, setOldData] = useState({});
  const [mode, setMode] = useState('tutor');
  const [pointer, setPointer] = useState(0);
  const [loading, setLoading] = useState(false);


  const [showStaticModal, setShowStaticModal] = useState(false);
  const [staticDataImported, setStaticDataImported] = useState(false);
  const [showEditErrorModal, setShowEditErrorModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [showLoadingModal, setShowLoadingModal] = useState(false);

  const [taskId, setTaskId] = useState("")

  const [fieldsConfig, setFieldsConfig] = useState({})

  useEffect(() => {
    if (Object.keys(data).length <= 0 || !staticDataImported) return

    if(JSON.stringify(data) === JSON.stringify(oldData)) return

    async function fetchData() {
      if (mode) {
        let localConfig = fieldsConfig
        if (fieldsConfig["type"] != mode) localConfig = mode === 'tutor' ? await getConfigTutorData() : await getConfigStudentData()

        setFieldsConfig(localConfig);
        const remapedData = Object.fromEntries(
          Object.entries(data).map(([key, row]) => [key, remapData(row, localConfig)])
        )

        setData(remapedData);
        setOldData(remapedData)
      }
    }

    fetchData()
  }, [mode, data, staticDataImported]);

  const handleFileUpload = async (event, mode) => {
      const file = event.target.files[0];
      if (file && file.type === 'text/csv') {
          try {
            setShowLoadingModal(true)
            const formData = new FormData();
            formData.append('csv', file);
            formData.append('type', mode);

            const response = await callAPI({
                request: "database/importData/validCheck",
                method: "POST",
                params: formData
            });
            
            const data = response?.data

            if (data) {
              setStaticFields(data.missingEntries);
              setErrors(data.errors);
              setMode(mode)
              setData(data.data);

              setShowLoadingModal(false);

              setShowStaticModal(true);
              console.log(data)
            }
          } catch (error) {
              console.error("Error uploading CSV file:", error);
              alert("There was an error uploading the file.");
          }
      } else {
          alert('Please select a valid CSV file.');
      }
  };

  const handleStaticFieldsSave = async (updatedFields) => {
    if (loading) return;
    setLoading(true);
  
    if (Object.keys(updatedFields).length > 0) {
      try {
        const response = await callAPI({
          request: "database/importData/importStaticFields",
          method: "post",
          params: { data: updatedFields }
        });
  
      } catch (error) {
        console.error("Error saving static fields:", error);
      }
    }
    
    setStaticDataImported(true);
    setShowErrorModal(true)

    setLoading(false);
  };
  

  const handleFixError = (lineNumber) => {
    if (loading) return;

    setPointer(lineNumber);

    setShowErrorModal(false);
    setShowEditErrorModal(true)
  };

  const onDelete = (lineNumber) => {
    if (loading) return;

    const updatedErrors = { ...errors };
    delete updatedErrors[lineNumber];
    setErrors(updatedErrors);

    const updatedData = { ...data };
    delete updatedData[lineNumber];
    setData(updatedData);
  };

  const onSkip = (lineNumber) => {
    if (loading) return;

    const updatedErrors = { ...errors };
    delete updatedErrors[lineNumber];

    setErrors(updatedErrors);
  };

  const onSkipRemaining = () => {
    if (loading) return;

    setErrors({});
  };

  const onEditErrorSave = (updatedData, lineNumber) => {
    if (loading) return;

    const newData = { ...data };
    newData[lineNumber] = updatedData
    setData(newData);

    const updatedErrors = { ...errors };
    delete updatedErrors[lineNumber];
    setErrors(updatedErrors);

    setShowEditErrorModal(false)
    setShowErrorModal(true);
  }
  

  const onContinue = async () => {
    if (loading) return;
    setLoading(true)

    if (Object.keys(data).length > 0){
      const response = await callAPI({
        request: "database/importData/massImportEntries",
        method: "post",
        params: { data: data, type: mode}
      });

      setTaskId(response?.data?.task || "")
      setShowErrorModal(false)
      setShowProgressModal(true)
    }

    setLoading(false)
  };

  const openErrorModal = () => {
    setShowStaticModal(false);
    setShowErrorModal(true);
    setShowEditErrorModal(false)
  };

  return (
    <div>
      <div>
        <h3>Upload Tutor CSV File</h3>
        <input
          type="file"
          accept=".csv"
          onChange={(event) => handleFileUpload(event, "tutor")}
        />
      </div>

      <div>
        <h3>Upload Student CSV File</h3>
        <input
          type="file"
          accept=".csv"
          onChange={(event) => handleFileUpload(event, "student")}
        />
      </div>

      {showLoadingModal && (
        <LoadingModal
         onClose={() => setShowLoadingModal(false)}
         title={"Processing data..."}
        />
      )}

      {/* Static Field Editor Modal */}
      {showStaticModal && (
        <StaticFieldEditor
          staticFields={staticFields}
          onSave={handleStaticFieldsSave}
          onClose={() => {
            setShowStaticModal(false)
          }}
        />
      )}

      {/* Error List Modal */}
      {showErrorModal && (
        <ErrorList
          errors={errors}
          data={data}
          onFix={handleFixError}
          onContinue={onContinue}
          onDelete={onDelete}
          onSkip={onSkip}
          onSkipRemaining={onSkipRemaining}
          onClose={() => {
            setShowErrorModal(false)
          }}
          loading={loading}

        />
      )}

      {showEditErrorModal && mode && fieldsConfig != {} && (
        <ErrorModal
          initialData={data}
          lineNumber = {pointer}
          fieldsConfig={fieldsConfig}
          onSave={onEditErrorSave}
          onClose={openErrorModal}
        />
      )}

      {showProgressModal && (
        <ProgressModal
          taskId = {taskId}
          onClose={() => {
            setShowProgressModal(false)
          }}
        />
      )}

    </div>
  );
};

export default DataImport;
